import { Logo } from "../assets/images";
import LanguageSelector from "./LanguageSelector";
import { router } from "../routes";

function Header() {
  const handleHome = () => {
    router.navigate("/");
  };

  return (
    <div className="flex items-center gap-2  h-[70px] fixed top-0 w-full left-0 bg-blue-light px-4 py-2 z-50">
      <div className="max-w-[628px] h-full flex items-center w-full justify-between mx-auto gap-4">
        <div onClick={handleHome}>
          <img
            src={Logo}
            alt="MyProtectAll"
            className="cursor-pointer mx-auto"
          />
        </div>
        <div className="language">
          <LanguageSelector />
        </div>
      </div>
    </div>
  );
}

export default Header;
